/**
 * Angular 2 decorators and services
 */
import {
    Component,
    OnInit,
    OnChanges,
    ViewEncapsulation,
    Input
} from '@angular/core';
import {AppState} from './app.service';
import {TranslateService} from "ng2-translate";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {LoginComponent} from "./login/login.component";
import {UserVM} from "./models/UserVM";

import {BaseHttpService} from "./services/base-http-service";
import {AuthService} from "./services/auth/AuthService";
import "../../node_modules/swiper/dist/js/swiper.js"
import {AuthGuard} from "./services/auth/AuthGuard";
import {CompanyService} from "./services/company-service/company-service";
import {CompanyVM} from "./models/CompanyVM.model";
import {Title, Meta} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {CategoryService} from "./services/category/category.service";
import {ServiceItemDetailVM} from "./models/ServiceItemDetailVM";
import {IAppConfig} from "./models/app-config.model";
import {AppConfig} from "./services/app.config";
import {CacheUtilService} from "./services/cache-util/CacheUtilService";
import {APP_VERSION} from "./services/constants";


//import '../assets/js/jquery.min.js';
//import '../assets/js/external.js';

/**
 * App Component
 * Top Level Component
 */
declare var jquery: any;
declare var $: any;
declare var HomePageJs: any;


@Component({
    selector: 'app',
    encapsulation: ViewEncapsulation.None,
    styles: [
        require('./app.component.css')
    ],
    template: require('./app.component.html')
})
export class AppComponent implements OnInit, OnChanges {
    //importing app settings
    public setting: IAppConfig = AppConfig.settings;

    public isAuthenticated;
    public account: UserVM = new UserVM();
    public company: CompanyVM;
    public logo: any;
    public inIframe: boolean = false;
    public showFooter: boolean = true;
    public isReserwebSubs: boolean = true;
    public isXbody: boolean = false;
    public servant_label = 'پرسنل';

    servantListAccessModeIsMENU: boolean = false;
    @Input() public serviceItemDetail: ServiceItemDetailVM;
    public themeType = 'MODERN_THEME';

    public testData = ["havij", "havij", "havij", "havij", "havij", "havij", "havij", "havij", "havij", "havij"];

    constructor(public appState: AppState,
                public dialog: MatDialog,
                public authService: AuthService,
                public authGuard: AuthGuard,
                private baseHttpService: BaseHttpService,
                private companyService: CompanyService,
                private categoryService: CategoryService,
                private pageTitle: Title,
                private meta: Meta,
                translate: TranslateService,
                private cacheUtilService: CacheUtilService
    ) {

        translate.setDefaultLang('fa');

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use('fa');
    }

    ngOnChanges() {

    }

    openLoginDialog(): void {
        //this.authGuard.openLoginDialog();
        let dialogRef = this.dialog.open(LoginComponent, {
            width: '600px',
            data: {name: 'saeed'}
        });

        dialogRef.afterClosed().subscribe(result => {
            this.authService.updateLoginStatus();

        });
    }

    gotoInvalidUrlPage() {

    }

    loadCompanyData() {
        let parent = this;

        this.companyService.getCompanyInfo().subscribe((c) => {
            if (!c.id) {
                this.gotoInvalidUrlPage();
            }

            parent.company = c;

            parent.setPageTitle();
            parent.setMetaTags();
            let footerViewMode = this.companyService.getCompanyCustomSetting(c, "footerViewMode");
            if (footerViewMode && footerViewMode == 'HIDDEN') {
                parent.showFooter = false;
            }

            parent.companyService.getCompanyLogoImage(c).subscribe(((logo) => {
                parent.logo = logo;
            }));
        })
    }

    servantLabel() {

    }

    public setPageTitle() {
        this.pageTitle.setTitle(this.company.title);
    }

    public setMetaTags() {
        this.meta.addTag({name: 'description', content: this.company.description + ':' + this.company.title});
        //this.meta.addTag({ name: 'author', content: 'talkingdotnet' });
        //this.meta.addTag({ name: 'keywords', content: 'Angular, Meta Service' });
    }

    public ngOnInit() {
        // this.company = new CompanyVM('');
        // this.company.id = 0;

        // 11111111
        if (sessionStorage.getItem("logout") !== 'true') {
            this.authService.logout(false);
            sessionStorage.setItem("logout", "true")
        }


        this.inIframe = this.companyService.inIframe();
        // if (this.inIframe) {
        //   this.showFooter = false;
        // }

        let parent = this;
        this.checkStorageHistory(parent.companyService.getBaseUrl());


        parent.companyService.getCompanyInfo().subscribe((company) => {

            let serLabel = this.companyService.getCompanyCustomSetting(company, 'servants_label');
            let accessMode = this.companyService.getCompanyCustomSetting(company, 'servant_list_access_mode');
            if (accessMode === 'MENU') {
                this.servantListAccessModeIsMENU = true;
            }
            //dont change the servantListAccessModeIsMENU bcz you will forget to delete this line
            //  this.servantListAccessModeIsMENU = true; //this line is for testing and should be deleted
            if (!serLabel)
                serLabel = parent.categoryService.getServiceCustomSetting(this.serviceItemDetail, 'servants_label');
            if (serLabel) {
                parent.servant_label = serLabel;
            }
            this.checkTheme(company);

        });
    }

    public checkStorageHistory(keyUrl) {

        // let appVersion = '';
        // appVersion = this.cacheUtilService.getFromCach('appVersion');
        //
        // if(!appVersion || appVersion =='' || APP_VERSION != appVersion)
        // {
        //    this.cacheUtilService.clearCache();
        //    this.cacheUtilService.storeInCache('appVersion',APP_VERSION);
        // }

    }

    public ngAfterViewInit() {
        HomePageJs.init();
        this.loadCompanyData();
    }

    logout() {
        this.authService.logout();
    }

    goToAppLink() {
        let url = this.setting.ui.app_domain;
        window.open(url, "_blank");
    }

    public getMainContentClass() {
        if (this.company && this.company.setting && this.company.setting.themeSettingInfo
            && this.company.setting.themeSettingInfo.themeType && this.company.setting.themeSettingInfo.themeType == 'MODERN_THEME') {
            return 'main_content_modern';
        }
    }

    checkTheme(company) {

        const parent = this;

        if (company && company.setting && company.setting.themeSettingInfo
            && company.setting.themeSettingInfo.themeType && company.setting.themeSettingInfo.themeType == 'MODERN_THEME') {
            parent.themeType = 'MODERN_THEME';

            this.setThemeColor(company);
        } else {
            parent.themeType = 'DEFAULT_THEME';
        }


    }

    setThemeColor(company) {


        if (company && company.setting && company.setting.themeSettingInfo
            && company.setting.themeSettingInfo.themePrimaryColor)
            document.documentElement.style.setProperty('--rw-primary-color', company.setting.themeSettingInfo.themePrimaryColor);

        if (company && company.setting && company.setting.themeSettingInfo
            && company.setting.themeSettingInfo.themeSecondaryColor)
            document.documentElement.style.setProperty('--rw-secondary-color', company.setting.themeSettingInfo.themeSecondaryColor);

    }

}

/**
 * Please review the https://github.com/AngularClass/angular2-examples/ repo for
 * more angular app examples that you may copy/paste
 * (The examples may not be updated as quickly. Please open an issue on github for us to update it)
 * For help or questions please contact us at @AngularClass on twitter
 * or our chat on Slack at https://AngularClass.com/slack-join
 */



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/app.component.ts